// @flow
import Router from 'next/router'

type RedirectProps = {
  path: string
}

const Redirect = ({ path }: RedirectProps) => {
  Router.replace(path)
  return null
}

export default Redirect
